import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Widget} from '../../components/layout/widget/widget';
import {WidgetLinkingGroupService} from '../../components/widget-linking-group/index';
import {Side} from '../../enums/side';
import {FloatWidgetFactory} from '../../pages/dashboard/float-layout/float-widget.factory';
import {DEX_LP_TRADE_WIDGET_TYPE_ID} from '../dex-lp-trade-widget/dex-lp-trade-widget-type-id';
import {DexLpTradeWidgetSettingsDef} from '../dex-lp-trade-widget/settings/index';
import {DexLpCollapsedWidget} from './dex-lp-collapsed-widget';
import {DexLpCollapsedWidgetImpl} from './dex-lp-collapsed-widget.impl';

@Component({
    selector:        'dex-lp-collapsed-widget',
    templateUrl:     './dex-lp-collapsed-widget.component.html',
    styleUrls:       ['./dex-lp-collapsed-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone:      false,
    viewProviders:   [
        FloatWidgetFactory
    ]
})
export class DexLpCollapsedWidgetComponent {
    public readonly widget = inject(Widget) as DexLpCollapsedWidget;
    public readonly widgetImpl: DexLpCollapsedWidgetImpl = this.widget.implementationInstance;

    private readonly widgetLinkingGroupService = inject(WidgetLinkingGroupService);
    private readonly floatWidgetFactory = inject(FloatWidgetFactory);

    public handleSymbolClick(symbol: string): void {
        const widget = this.widget;

        this.widgetLinkingGroupService.setLinkingGroupSettings(
            widget.linkingGroupId,
            widget.tabId,
            {
                trancheSymbol: symbol
            } as any
        );
    }

    public handleTradeClick(symbol: string, side: Side): void {
        this.floatWidgetFactory.createFloatWidget<DexLpTradeWidgetSettingsDef>(
            DEX_LP_TRADE_WIDGET_TYPE_ID,
            {
                title:     null,
                side,
                symbol
            }
        );
    }
}
